import { FC, useState } from 'react';
import './index.less';
const DOTS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

export interface IProps {
  tip?: string;
  width?: number;
}

export const Loading: FC<IProps> = (props) => {
  const { tip = '加载中…', width = 56 } = props;
  const dots = useState<number[]>(DOTS)[0];

  return (
    <div className="l-loading">
      <div className="l-dot-wrapper" style={{ width: width, height: width }}>
        {dots.map((idx) => (
          <div key={idx} className={'l-dot l-dot-' + idx} />
        ))}
      </div>
      <p className="l-loading-tip">{tip}</p>
    </div>
  );
};
